import {
  COLLECTIONS_DELETE_ALL_ITEMS_BEGIN,
  COLLECTIONS_DELETE_ALL_ITEMS_SUCCESS,
  COLLECTIONS_DELETE_ALL_ITEMS_FAILURE,
  COLLECTIONS_DELETE_ALL_ITEMS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteAllItems(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_ALL_ITEMS_BEGIN,
    });
    const { projectId, collectionName, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/delete-all-item`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: COLLECTIONS_DELETE_ALL_ITEMS_SUCCESS,
              data: res,
            });
            Mixpanel.track('Deleted Collection Items.', { collectionName });
            toast.success('Collection Items Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_ALL_ITEMS_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Deleted Collection Itmes Failed.', {
              collectionName: args.collectionName,
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed to Delete Collection Items: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_ALL_ITEMS_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Deleted Collection Itmes Failed.', {
            collectionName: args.collectionName,
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed to Delete Collection Items: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteAllItemsError() {
  return {
    type: COLLECTIONS_DELETE_ALL_ITEMS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_ALL_ITEMS_BEGIN:
      return {
        ...state,
        deleteAllItemsPending: true,
        deleteAllItemsError: null,
      };

    case COLLECTIONS_DELETE_ALL_ITEMS_SUCCESS:
      return {
        ...state,
        deleteAllItemsPending: false,
        deleteAllItemsError: null,
        items: [],
        totalItemPages: null,
        selectedItem: null,
      };

    case COLLECTIONS_DELETE_ALL_ITEMS_FAILURE:
      return {
        ...state,
        deleteAllItemsPending: false,
        deleteAllItemsError: action.data.error,
      };

    case COLLECTIONS_DELETE_ALL_ITEMS_DISMISS_ERROR:
      return {
        ...state,
        deleteAllItemsError: null,
      };

    default:
      return state;
  }
}
